import { render, staticRenderFns } from "./StockBreakdownRoomQtyViewer.vue?vue&type=template&id=afbfddaa"
import script from "./StockBreakdownRoomQtyViewer.vue?vue&type=script&lang=js"
export * from "./StockBreakdownRoomQtyViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports